// top
var backToTop = document.querySelector('.back-to-top');

//Triggered when the page scrolls
    
window.addEventListener('scroll', function() {
//When the scrolling height exceeds 300, display the button
    if (window.pageYOffset > 300) {
        backToTop.style.opacity = 1;
        backToTop.style.visibility = 'visible';
    } else {
        backToTop.style.opacity = 0;
        backToTop.style.visibility = 'hidden';
    }
});

//When the user clicks the return to top button, return to the top of the page
backToTop.addEventListener('click', function(event) {
    event.preventDefault();
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});

//nav
window.addEventListener('scroll', function () {
    let header = document.querySelector('.header-wrapper');
    if (window.scrollY > 100) {
        header.classList.add('sticky');
    } else {
        header.classList.remove('sticky');
    }
});